import { Component } from '@angular/core';
import { HeroComponent } from '../hero/hero.component';
import { NewsComponent } from '../news/news.component';
import { AboutComponent } from '../about/about.component';
import { WeatherConditionsComponent } from '../station/pages/weather-conditions/weather-conditions.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeroComponent,
    WeatherConditionsComponent,
    NewsComponent,
    AboutComponent,
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {}
